/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeOwnedApplicationsCountQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  businessOwnerId: Types.Scalars['ID']['input'];
}>;


export type ClientEmployeeOwnedApplicationsCountQuery = { __typename: 'Query', clientApplications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ClientEmployeeOwnedApplicationsCountDocument = new TypedDocumentString(`
    query ClientEmployeeOwnedApplicationsCount($clientId: UUID!, $businessOwnerId: ID!) {
  clientApplications(
    clientId: $clientId
    resource_IsPrimaryResource: true
    businessOwner_In: [$businessOwnerId]
    first: 0
  ) {
    totalCount
  }
}
    `);

export const useClientEmployeeOwnedApplicationsCountQuery = <
      TData = ClientEmployeeOwnedApplicationsCountQuery,
      TError = unknown
    >(
      variables: ClientEmployeeOwnedApplicationsCountQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>(
      {
    queryKey: ['ClientEmployeeOwnedApplicationsCount', variables],
    queryFn: fetcher<ClientEmployeeOwnedApplicationsCountQuery, ClientEmployeeOwnedApplicationsCountQueryVariables>(ClientEmployeeOwnedApplicationsCountDocument, variables),
    ...options
  }
    )};

useClientEmployeeOwnedApplicationsCountQuery.getKey = (variables: ClientEmployeeOwnedApplicationsCountQueryVariables) => ['ClientEmployeeOwnedApplicationsCount', variables];

export const useInfiniteClientEmployeeOwnedApplicationsCountQuery = <
      TData = InfiniteData<ClientEmployeeOwnedApplicationsCountQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeOwnedApplicationsCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeOwnedApplicationsCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployeeOwnedApplicationsCount.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeOwnedApplicationsCountQuery, ClientEmployeeOwnedApplicationsCountQueryVariables>(ClientEmployeeOwnedApplicationsCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeOwnedApplicationsCountQuery.getKey = (variables: ClientEmployeeOwnedApplicationsCountQueryVariables) => ['ClientEmployeeOwnedApplicationsCount.infinite', variables];


useClientEmployeeOwnedApplicationsCountQuery.fetcher = (variables: ClientEmployeeOwnedApplicationsCountQueryVariables) => fetcher<ClientEmployeeOwnedApplicationsCountQuery, ClientEmployeeOwnedApplicationsCountQueryVariables>(ClientEmployeeOwnedApplicationsCountDocument, variables);
